export const SERIES_FLATPICKR = {
  monthSelectorType: "static",
  disableMobile: true,
  locale: {
    weekdays: {
      shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    },
  },
};

export const tagSeriesCalendar = (_dates, _str, fp) =>
  fp.calendarContainer.classList.add("series-flatpickr");
